import { gql, useQuery, useMutation } from '@apollo/client';

const GET_ALL_INTEGRATIONS = gql`
  query GetApis {
    Apis {
      edges {
        node {
          id
          name
          type
          status
          transformation
          endpoints {
            connectorId
            method
            uri
            variables {
              type
              dataType
              name
              value
            }
          }
          additionalResolvers {
            type
            transformation
            endpoints {
              connectorId
              method
              uri
              variables {
                type
                dataType
                name
                value
              }
            }
          }
          description
        }
      }
    }
  }
`;

export const useIntegrations = () => {
  return useQuery(GET_ALL_INTEGRATIONS);
};

export const useCreateIntegration = () => {
  return useMutation(
    gql`
      mutation CreateAPI($api: CreateApiInput!) {
        CreateApi(input: $api) {
          id
          name
          type
          status
          transformation
          endpoints {
            connectorId
            method
            uri
            variables {
              type
              dataType
              name
              value
            }
          }
          additionalResolvers {
            type
            transformation
            endpoints {
              connectorId
              method
              uri
              variables {
                type
                dataType
                name
                value
              }
            }
          }
          description
        }
      }
    `,
    {
      update(cache, { data }) {
        try {
          const createdApi = data?.CreateApi;
          const existingApis = cache.readQuery<any>({
            query: GET_ALL_INTEGRATIONS,
          }).Apis;

          if (existingApis?.edges && createdApi?.id) {
            cache.writeQuery({
              query: GET_ALL_INTEGRATIONS,
              data: {
                Apis: { edges: [...existingApis.edges, { node: createdApi }] },
              },
            });
          }
        } catch (error) {
          console.log('Failed to add the new API to the existing cache', { error });
        }
      },
    },
  );
};

export const useIntegration = (id: string) => {
  return useQuery(
    gql`
      query GetApi($id: String!) {
        Api(id: $id) {
          id
          name
          type
          status
          transformation
          endpoints {
            connectorId
            method
            uri
            variables {
              type
              dataType
              name
              value
            }
          }
          additionalResolvers {
            type
            transformation
            endpoints {
              connectorId
              method
              uri
              variables {
                type
                dataType
                name
                value
              }
            }
          }
          description
        }
      }
    `,
    { variables: { id } },
  );
};

export const useUpdateIntegration = () => {
  return useMutation(
    gql`
      mutation UpdateAPI($api: UpdateApiInput!) {
        UpdateApi(input: $api) {
          id
          name
          type
          status
          transformation
          endpoints {
            connectorId
            method
            uri
            variables {
              type
              dataType
              name
              value
            }
          }
          additionalResolvers {
            type
            transformation
            endpoints {
              connectorId
              method
              uri
              variables {
                type
                dataType
                name
                value
              }
            }
          }
          description
        }
      }
    `,
  );
};
